export default {
  termsAndConditions: {
    part3: 'y la',
    part4: 'Política de protección de datos personales',
  },

  newsAndPromotions: 'Acepto recibir novedades, promociones y actualizaciones.',
}
